import { createAction } from 'redux-act';

export const setZipCodePreValidationLoading = createAction(
  'Set Zip code prevalidation loading'
);
export const setZipCodeValidationLoading = createAction(
  'Set Zip code validation loading'
);

export const setZipCodeInfo = createAction('Set Zip code info');

export const prevalidateZipCode = createAction('Prevalidate Zip code');
export const validateZipCode = createAction('Validate Zip code');

export const zipCodeReset = createAction('Reset Zip code state');
